import styled from "styled-components"

export const MapPin = styled.img`
  width: 20px;
  cursor: pointer;
`
